import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import AboutUs from "../components/AboutUs";


function Home() {
    return (
        <div className="d-flex flex-column min-vh-100" style={{ backgroundColor: "#fff" }}>
            <Navbar />
            <AboutUs />
            <br></br>
            <br></br>
            <br></br>
            <Footer />

        </div>
    );
}

export default Home;
